import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useGetAssignedSurveysQuery } from '../../app/userApi/userApi';
import Datatable from '../../components/shared/datatable/Datatable';
import AssignServeyModal from '../../components/shared/modalContent/AssignServeyModal'
import { getStatusClass } from '../../helpers/Utils';
import { useNavigate } from 'react-router-dom';
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb';
import UnassignSurveyModal from '../../components/shared/modalContent/UnassignSurveyModal';
import { useGetUserAccountsQuery } from '../../app/userApi/userApi';
import { formatDateToMDY } from '../../helpers/Utils';
import Button from '../../components/shared/buttons/button';
import { Col, Row } from 'react-bootstrap';
const SurveyView = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const userName = location.state?.userName;
  const userEmail = location.state?.userEmail;
  const [selectedSurveyId, setSelectedSurveyId] = useState(null); // new state for surveyId

  const [showAssignServeyModal, setShowAssignServeyModal] = useState(false)
  const [showUnassignSurveyModal, setShowUnassignSurveyModal] = useState(false)
  const [search, setSearch] = useState(null)
  const { id } = useParams();
  const { leadId } = useParams();
  console.log(leadId,"leadId-->");
  
  const [page, setPage] = useState(1);
  const limit = 10;

  const shouldSkip =  !(id && leadId);

  const { data: assignedSurveys, isLoading, isFetching } = useGetAssignedSurveysQuery(
    { userId: id, leadId, page, limit, search },
    { skip: shouldSkip }
  );

  const handleFilterSearch = (value) => {
    setSearch(value);
    setPage(1); // Optional: reset to first page on new search
  };

  const columns = [
    { label: 'Survey Title', accessor: 'title' },
    { label: 'Description', accessor: 'description' },
    {
      label: "Status",
      cell: ({ row }) => (
        <>
          {row?.status === 'submitted' && <span className={`${getStatusClass(row?.status)} badge`}
            onClick={() => {
              if (row?.status === "submitted") {
                navigate(`/users/submitted-answers/${id}`, {
                  state: {
                    leadId: leadId,
                    surveyId: row?._id,
                  },
                });
              }
            }}
          >
            View Submition
          </span>}
          {row?.status === 'assigned' && <span
            onClick={() => {
              setSelectedSurveyId(row?._id); // set selected survey id
              setShowUnassignSurveyModal(true);
            }}
            className={`${getStatusClass(row?.status)} badge cursor-pointer`}
          >
            Unassign
          </span>}

          {row?.status === 'in_progress' && <span className={`${getStatusClass(row?.status)} badge`}>
            In Progress
          </span>}
        </>
      )
    },


  ];
  const breadcrumbItems = [
    { label: 'Users', path: '/users' },
    { label: `User Details - ${id}` }, // last one (no path) is the current page
  ];
  return (

    <div>
      <CommonBreadcrumb items={breadcrumbItems} />
      <AssignServeyModal show={showAssignServeyModal} setShow={setShowAssignServeyModal} userId={id} leadId={leadId} />
      <UnassignSurveyModal show={showUnassignSurveyModal} setShow={setShowUnassignSurveyModal} userId={id} surveyId={selectedSurveyId} leadId={leadId} />
 

      <Datatable
        tableData={assignedSurveys?.data}
        columns={columns}
        page={page}
        onPageChange={(newPage) => setPage(newPage)}
        isLoading={isLoading}
        showPegination={true}
        showFilter={true}
        isFetching={isFetching}
        title={userName}
        subTitle={userEmail}
        buttonTitle="Assign Survey"
        onFilterSearch={handleFilterSearch}
        onClick={() => { setShowAssignServeyModal(true) }}
      />
    </div>
  );
};

export default SurveyView;
